import ary from '@ravnur/nanoutils/ary';
import { showErrorNotification } from '@ravnur/notifications/service';

import { convertFromError } from '@/transformers/notifications';

export function $processException(e: Dictionary<unknown> | unknown) {
  convertFromError(e).forEach(ary(1, showErrorNotification));
}
